import NextImage from 'next/image';
import nextLink from 'next/link';
import { notFound as nextNotFound } from 'next/navigation';

export const notFound = nextNotFound;
export const Link = nextLink;
export const Image = NextImage;
